var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon24Wallet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-24-wallet",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7098",
    "data-name": "Rectangle 7098",
    width: 24,
    height: 24,
    fill: "rgba(255,255,255,0)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "wallet-money-icon",
    d: "M14.168,10.746h2.71v-.525a2.11,2.11,0,0,0-.721-1.2,1.985,1.985,0,0,0-1.22-.334l-11.114,0a.5.5,0,1,1,0-.99h11.1a2.927,2.927,0,0,1,1.821.528c.045.034.09.069.133.106v-.3a1.7,1.7,0,0,0-1.689-1.689h-.357l-.046,0L14.611,7h-1.2l.712-2.673a1.126,1.126,0,0,1-.8-1.378L9.364,1.89a1.127,1.127,0,0,1-1.377.8L6.824,7H5.585L7.47,0l8.409,2.253-.829,3.1h.139a2.692,2.692,0,0,1,2.679,2.68v2.737a1.45,1.45,0,0,1,1.164,1.419V15.45a1.514,1.514,0,0,1-1.164,1.469v1.965a2.673,2.673,0,0,1-.788,1.892l-.031.029a2.672,2.672,0,0,1-1.86.759H2.679A2.688,2.688,0,0,1,0,18.884V8.037a2.686,2.686,0,0,1,2.679-2.68h1.57L5.493.737l1.187.318L5.049,7H3.806l.176-.653h-1.3A1.695,1.695,0,0,0,.99,8.037V18.884a1.7,1.7,0,0,0,1.689,1.689H15.189a1.68,1.68,0,0,0,1.168-.474l.023-.024a1.683,1.683,0,0,0,.5-1.191V16.959h-2.71a3.034,3.034,0,0,1-2.148-.893l-.052-.057a3.032,3.032,0,0,1-.841-2.092v-.131a3.033,3.033,0,0,1,.893-2.145l.005-.005a3.032,3.032,0,0,1,2.143-.891Zm-4.03-3.918a1.358,1.358,0,1,0-.96-1.663A1.358,1.358,0,0,0,10.138,6.828Zm5.118,6.186,0,0a1.187,1.187,0,0,1,0,1.673l0,0a1.187,1.187,0,0,1-1.674,0l0,0a1.187,1.187,0,0,1,0-1.674l0,0A1.187,1.187,0,0,1,15.255,13.014Z",
    transform: "translate(3 1)",
    fill: "#1dbbbe",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon24Wallet);
export default __webpack_public_path__ + "static/media/icon-24-wallet.eac3e836f33797bfe9e90b7012d65330.svg";
export { ForwardRef as ReactComponent };